import { useQuery } from '@tanstack/react-query';
import { unwrap } from '../common/apiCommons';
import axios from 'axios';

export type User = {
  id: number;
  username: string;
  first_name: string;
  last_name: string;
};

export function useUsers() {
  return useQuery({
    queryKey: ['users'],
    queryFn: () => axios.get<User[]>('/company/users/list/').then(unwrap),
    select: (data) => {
      return data.reduce(
        (acc, user) => {
          acc[user.id] = user;
          return acc;
        },
        {} as { [key: number]: User },
      );
    },
  });
}
